import React from 'react'
import { Route, Routes } from 'react-router-dom'
import './App.css'
import { Stats } from './Stats/Stats'
import { Upload } from './Upload/Upload'

function App(): JSX.Element {
	return (
		<React.Fragment>
			<Routes>
				<Route path='/' element={<Stats />} />
				<Route path='/upload' element={<Upload />} />
			</Routes>
		</React.Fragment>
	)
}

export default App
